import { HttpClient } from '@angular/common/http';
import { config } from '../app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NewsService = /** @class */ (function () {
    function NewsService(http) {
        this.http = http;
    }
    NewsService.prototype.getNews = function (data) {
        return this.http.post(config.api + "/NewsPreview/GetNewsPreviews", data);
    };
    NewsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NewsService_Factory() { return new NewsService(i0.ɵɵinject(i1.HttpClient)); }, token: NewsService, providedIn: "root" });
    return NewsService;
}());
export { NewsService };
